import { generatePath, Link, useNavigate } from 'react-router';
import { Add, Launch, Toc } from '@mui/icons-material';
import theme from '@/constants/theme';
import Table from '@/components/dataDisplay/Table';
import Button from '@/components/input/Button';
import { Route } from '@/services/routes/route.vm';
import { routes } from '@/constants/routes';
import useLearningRoutes from '@/context/routes/hook';
import { useMemo, useState } from 'react';

enum Filter {
  ORDER_ASC = 'ORDER_ASC',
  ORDER_DESC = 'ORDER_DESC',
}

const AdminRoutes = () => {
  const { routesList } = useLearningRoutes(); 
  const navigate = useNavigate();
  const [filter] = useState<Filter>(Filter.ORDER_DESC);

  const orderedRoutesList = useMemo(
    () =>
      routesList.sort((a, b) => {
        if (filter === Filter.ORDER_ASC) {
          return b.order - a.order;
        }
        return a.order - b.order;
      }),
    [filter, routesList],
  );

  const mapRoutes = (routes: Route[]) => {
    return routes.map((route) => ({
      id: route.id,
      description: route.description,
      title: route.title,
      type: route.type,
      order: route.order,
    }));
  };

  const handleCreateRoute = () => {
    navigate(routes.admin.routes.create);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        padding: 16,
        paddingTop: 32,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h1 style={{ color: theme.colors.text.title }}>Rutas</h1>

        <div style={{ display: 'flex', gap: 16 }}>
          <Button variant="outline" Icon={Toc} onClick={() => navigate(routes.admin.routes.reorder)}>
            Reordenar
          </Button>
          <Button Icon={Add} onClick={handleCreateRoute}>
            Crear Ruta
          </Button>
        </div>
      </div>
      <Table
        columns={[
          {
            title: 'Orden',
            field: 'order',
            render: (row: any) => row.order,
          },
          {
            title: 'Título',
            field: 'title',
            render: (row: any) => (
              <Link
                to={generatePath(routes.admin.routes.detail, { routeId: row.id })}
                style={{
                  minWidth: 120,
                  display: 'flex',
                  gap: 8,
                  textDecoration: 'underline',
                }}
              >
                {row.title}
                <Launch
                  style={{
                    width: 12,
                    height: 12,
                    color: theme.colors.text.caption,
                  }}
                />
              </Link>
            ),
          },
          {
            title: 'Descripción',
            field: 'description',
            render: (row: any) => row.description,
          },
          { title: 'Tipo', field: 'type', render: (row: any) => row.type },
        ]}
        data={mapRoutes(orderedRoutesList)}
      />
    </div>
  );
};

export default AdminRoutes;
